import sprintf from './sprintf';
import { Translations, TranslateFunc } from './types';

export default function createTranslateFunction(
  messages: Translations,
): TranslateFunc {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (key = '', ...rest: any[]) => sprintf(messages[key] || key, ...rest);
}
